import React from "react";

const AIJourney = () => {
  const container = { maxWidth: "1000px", margin: "0 auto", padding: "120px 20px", color: "#fff", fontFamily: "'Plus Jakarta Sans', sans-serif" };
  const stepCard = { background: "rgba(255,255,255,0.03)", border: "1px solid rgba(0,212,255,0.2)", padding: "30px", borderRadius: "20px", marginBottom: "30px" };

  return (
    <div style={{ backgroundColor: "#05070a", minHeight: "100vh" }}>
      <div style={container}>
        <h1 style={{ fontSize: "3rem", marginBottom: "20px" }}>The <span style={{ color: "#00d4ff" }}>AI Adoption</span> Roadmap</h1>
        <p style={{ color: "#8b949e", marginBottom: "60px", fontSize: "1.2rem" }}>How we transition your enterprise into the age of intelligence.</p>

        <div style={stepCard}>
          <h2 style={{ color: "#00d4ff" }}>01. Discovery & Data Audit</h2>
          <p>We analyze your existing data infrastructure to identify high-impact AI opportunities and ensure data readiness for LLM training.</p>
        </div>

        <div style={stepCard}>
          <h2 style={{ color: "#00d4ff" }}>02. Custom Model Selection</h2>
          <p>We choose between OpenAI, Anthropic, or Open Source (Llama 3) architectures based on your security needs and budget.</p>
        </div>

        <div style={stepCard}>
          <h2 style={{ color: "#00d4ff" }}>03. Prototype & RAG Setup</h2>
          <p>Development of a Retrieval-Augmented Generation (RAG) system, allowing the AI to "read" your private corporate documents safely.</p>
        </div>

        <div style={stepCard}>
          <h2 style={{ color: "#00d4ff" }}>04. Full-Scale Deployment</h2>
          <p>Integrating the AI into your existing Slack, Microsoft Teams, or custom web dashboards for your employees and customers.</p>
        </div>
      </div>
    </div>
  );
};

export default AIJourney;